import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconCrosshair = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--crosshair")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M13.0006955,3.05500569 L13,6 C13,6.55228475 12.5522847,7 12,7 C11.4477153,7 11,6.55228475 11,6 L11,6 L11.0003032,3.05489527 C6.82844282,3.51592828 3.51592828,6.82844282 3.05489527,11.0003032 L6,11 C6.55228475,11 7,11.4477153 7,12 C7,12.5522847 6.55228475,13 6,13 L6,13 L3.05500569,13.0006955 C3.51645693,17.1720858 6.82877572,20.4841085 11.0003032,20.9451047 L11,18 C11,17.4477153 11.4477153,17 12,17 C12.5522847,17 13,17.4477153 13,18 L13,18 L13.0006955,20.9449943 C17.1717529,20.4835799 20.4835799,17.1717529 20.9449943,13.0006955 L18,13 C17.4477153,13 17,12.5522847 17,12 C17,11.4477153 17.4477153,11 18,11 L18,11 L20.9451047,11.0003032 C20.4841085,6.82877572 17.1720858,3.51645693 13.0006955,3.05500569 Z" id="icon--centivo--crosshair"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1847.000000, -411.000000)"/>
          <g id="Icon/crosshair">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--crosshair"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--crosshair"/>
          </g>
      </g>
  </IconWrapper>
)
